// import COMPANY_API from '@/api/masterData/company.js';
import BASEAPI from '@/api/dataBase.js';
import tradeMixin from './../../../../../../mixin/tradeMixin';
export const formFields = (ctx) => {
  return [
    {
      name: '结算单编号',
      prop: 'payableSettlementNo',
      disabled: true,
      type: 'input',
    },
    {
      prop: 'settlementCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      disabled:
        ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
          ? true
          : !ctx.isCreate,
    },
    {
      prop: 'settlementDepartmentNo',
      name: '部门',
      type: 'select',
      disabled:
        ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
          ? true
          : ctx.baseFormData?.settlementCompanyNo == '' || !ctx.isCreate,
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: ctx.changeDepartmentHandler,
    },
    // {
    //   name: '合同编号',
    //   prop: 'contractNo',
    //   type: 'searchTableSpec',
    //   searchType: 'contractMultipleProduct',
    //   extraData: {
    //     contractCategory: 'purchase',
    //     companyCode: ctx.baseFormData.settlementCompanyNo,
    //     departmentCode: ctx.baseFormData.settlementDepartmentNo,
    //   },
    //   isMultiple: true,
    //   disabled: !ctx.isCreate,
    //   changeMethod: ctx.changeContractMethod,
    //   currentValue: ctx.baseFormData?.contractNo,
    // },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'multransportContract',
      extraData: {
        // contractStatus: 'ZT03',
        contractType: '0',
        isCS: 'S',
        businessDepartmentCode: ctx.baseFormData.settlementDepartmentNo,
        platformCompanyName: ctx.baseFormData.settlementCompanyName,
      },
      isMultiple: true,
      changeMethod: ctx.changeContractMethod,
      currentValue: ctx.baseFormData?.contractNo,
      disabled: !ctx.isCreate,
    },
    {
      name: '供应商名称',
      prop: 'supplierName',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        companyCode: ctx.baseFormData.settlementCompanyNo,
        departmentCode: ctx.baseFormData.settlementDepartmentNo,
        partnerTypes: 'HZHB02',
      },
      isMultiple: true,
      // disabled: !ctx.isCreate,
      disabled: true,
      changeMethod: ctx.changeSupplyChainMethod,
      currentValue: ctx.baseFormData?.supplierName,
    },
    // {
    //   name: '是否多个投送人',
    //   prop: 'isMoreDeliverer',
    //   type: 'select',
    //   options: [
    //     {
    //       label: '否',
    //       value: '0',
    //     },
    //     {
    //       label: '是',
    //       value: '1',
    //     },
    //   ],
    //   disabled: true,
    // },
    {
      name: '原币结算总金额(含税)',
      prop: 'originalTotalAmount',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    {
      name: '原币结算总金额(不含税)',
      prop: 'originalTotalAmountWithoutTax',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    // {
    //   name: '原币总税额',
    //   prop: 'originalTotalTaxAmount',
    //   type: 'input',
    //   precision: 2,
    //   max: 999999999,
    //   disabled: true,
    // },
    {
      name: '本币结算总金额(含税)',
      prop: 'domesticTotalAmount',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    {
      name: '本币结算总金额(不含税)',
      prop: 'domesticTotalAmountWithoutTax',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    // {
    //   name: '本币总税额',
    //   prop: 'domesticTotalTaxAmount',
    //   type: 'input',
    //   precision: 2,
    //   max: 999999999,
    //   disabled: true,
    // },
    {
      name: '结算日期',
      prop: 'settlementDate',
      type: 'date',
      disabled: !ctx.isCreate,
    },
    {
      name: '应付帐期',
      prop: 'payableAccountPeriod',
      type: 'date',
      disabled: !ctx.isCreate,
      format: 'yyyy-MM',
    },
    {
      name: '结算单状态',
      prop: 'settlementStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementStatus || [],
      disabled: true,
    },
    {
      name: '付款状态',
      prop: 'paymentStatus',
      type: 'select',
      options: ctx.dictListMap?.pay_paymentStatus || [],
      disabled: true,
    },
    {
      name: '已付款金额',
      prop: 'paidAmount',
      type: 'input',
      disabled: true,
      precision: 2,
      max: 999999999,
      placeholder: '自动生成',
    },
    {
      name: '未付款金额',
      disabled: true,
      placeholder: '自动生成',
      prop: 'unpaidAmount',
      precision: 2,
      max: 999999999,
      type: 'input',
    },
    {
      name: '订单编号',
      prop: 'orderNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '是否代付',
      prop: 'anotherPayFlag',
      type: 'checkbox',
      disabled: !ctx.isCreate,
    },
    {
      name: '代付平台',
      prop: 'anotherPayPlatform',
      type: 'input',
      // disabled: !ctx.anotherPayStatus && !ctx.isCreate,
      disabled: !ctx.baseFormData.anotherPayFlag || !ctx.isCreate,
    },
    {
      prop: 'settlementCenter',
      name: '结算中心',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      disabled: !ctx.isCreate,
      changeMethod: ctx.changeSettlementCenterHandler,
    },

    {
      name: '结算类型',
      prop: 'settlementType',
      type: 'select',
      disabled: !ctx.isCreate,
      options: ctx.dictListMap?.settlementType || [],
    },
    {
      name: '业务类别',
      prop: 'settlementBusinessType',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    {
      // 申请日期到
      name: '项目编号',
      prop: 'projectInitiationNo',
      type: 'input',
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    {
      name: '汇率日期',
      prop: 'exchangeDate',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: !ctx.isCreate,
    },
    {
      name: '汇率',
      prop: 'exchangeRate',
      type: 'inputAmount',
      precision: 2,
      min: 0,
      max: 999999999,
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    {
      name: '币种',
      prop: 'currencyCode',
      type: 'ajaxSelect',
      apiUrl: BASEAPI.LIST_CURRENCY,
      clearable: true,
      filterable: true,
      valueKey: 'currencyCode',
      labelKey: 'currencyName',
      changeMethod: 'changeCurrencyHandler',
      method: 'get',
      valueType: 'object',
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    {
      name: '是否已打印',
      prop: 'printFlag',
      type: 'checkbox',
      disabled: true,
      placeholder: '自动生成',
    },
    {
      name: '业务人员',
      prop: 'salesmanName',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changePersonnelMethod,
      currentValue: ctx.baseFormData?.salesmanName,
      // disabled: !ctx.isCreate,
      disabled: true,
    },
    {
      name: '创建日期',
      prop: 'settlementCreateDate',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: true,
    },
    {
      name: '结算单用印类别',
      prop: 'signetType',
      type: 'select',
      options: [
        { value: '01', label: '业务章' },
        { value: '02', label: '公章' },
        { value: '03', label: '法人章' },
        { value: '04', label: '合同章' },
      ],
      // disabled: true,
      placeholder: '请选择结算单用印类别',
      multiple: true,
      disabled: !ctx.isCreate,
    },
    {
      name: '关联终结算单',
      prop: 'payPayableSettlementNo',
      type: 'input',
      disabled: true,
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'textarea',
      span: 24,
      maxlength: 500,
      disabled: !ctx.isCreate,
    },
  ];
};

export const formRules = {
  settlementCompanyNo: [{ required: true, message: '公司名称必填', trigger: 'change' }],
  settlementDepartmentNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  supplierName: [{ required: true, message: '必填字段', trigger: 'change' }],

  originalTotalAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  domesticTotalAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  // settlementStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // paymentStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // paidAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  // unpaidAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementType: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementBusinessType: [{ required: true, message: '必填字段', trigger: 'blur' }],
  // exchangeDate: [{ required: true, message: '必填字段', trigger: 'blur' }],
  exchangeRate: [{ required: true, message: '必填字段', trigger: 'change' }],
  currencyCode: [{ required: true, message: '必填字段', trigger: 'blur' }],
  salesmanName: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementCreateDate: [{ required: true, message: '必填字段', trigger: 'blur' }],
  signetType: [{ required: true, message: '必填字段', trigger: 'change' }],
};
export const editFormRules = {
  payableSettlementNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  // supplierName: [{ required: true, message: '必ss填字段', trigger: 'change' }],
  // settlementCreateDate: [{ required: true, message: '必填字段', trigger: 'change' }],

  // statementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // // receiveStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // invoiceAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
  // collectedAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
};
export const additionalEditFormRules = {
  anotherPayPlatform: [{ required: true, message: '必填字段', trigger: 'change' }],
};
export const contractNoFormRules = {
  contractNo: [{ required: true, message: '必填字段', trigger: 'change' }],
};

// 暴露出去
import { formatDate } from '@/utils';
export default {
  mixins: [tradeMixin],
  data() {
    return {
      formRules,
      baseFormData: {
        payableSettlementNo: '',
        settlementCompanyNo: '',
        settlementCompanyName: '',
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        isMoreDeliverer: '0',
        supplierNo: '',
        supplierName: '',
        orderNo: '',
        contractNo: '',
        originalTotalAmount: '',
        originalTotalAmountWithoutTax: '',
        originalTotalTaxAmount: '',
        domesticTotalAmountWithoutTax: '',
        domesticTotalTaxAmount: '',
        domesticTotalAmount: '',
        payableAccountPeriod: '',
        settlementDate: '',
        settlementStatus: '',
        paymentStatus: '',
        paidAmount: '0',
        unpaidAmount: '',
        anotherPayFlag: '',
        anotherPayPlatform: '',
        settlementCenter: '',
        settlementType: '2',
        settlementBusinessType: '02',
        projectInitiationNo: '',
        exchangeDate: formatDate(new Date()),
        exchangeRate: '',
        currencyCode: '',
        currencyName: '',
        printFlag: '',
        salesmanName: '',
        salesmanNo: '',
        payPayableSettlementNo: null,
        settlementCreateDate: formatDate(new Date()),
        remark: '',
        signetType: '',
      },
      noMust: true,
      isCreate: false,
      anotherPayStatus: false, //控制代付平台
      productList: [], //商品列表
    };
  },
  watch: {
    'baseFormData.settlementDate': {
      deep: true,
      handler: function (newV) {
        console.log('watch中：', newV);
        this.baseFormData.payableAccountPeriod = newV || this.baseFormData.payableAccountPeriod;
      },
    },
    'baseFormData.anotherPayFlag': {
      deep: true,
      handler: function (newV, oldV) {
        this.anotherPayStatus = newV;
        console.log(newV, 'watch中：', oldV);
      },
    },
    'baseFormData.originalTotalAmount': {
      deep: true,
      handler: function (newV) {
        // console.log('watch中：', newV);
        this.baseFormData.unpaidAmount = (+newV - this.baseFormData.paidAmount).toFixed(2);
      },
    },
    'baseFormData.paidAmount': {
      deep: true,
      handler: function (newV) {
        console.log('监听已付款金额', newV);
        this.baseFormData.unpaidAmount = (this.baseFormData.originalTotalAmount - +newV).toFixed(2);
      },
    },
    'baseFormData.settlementType': {
      deep: true,
      handler: function (newV) {
        console.log('watch中：', newV);
        if (newV == '1') {
          this.relatedStatus = false;
        }
        if (newV == '2') {
          this.relatedStatus = true;
        }
      },
    },
  },
  computed: {
    formColumn() {
      return formFields(this);
      // if (!this.noMust) {
      //   return formFieldsEdit(this);
      // } else {
      //   return formFields(this);
      // }
    },
    baseFormRules() {
      if (this.isCreate) {
        if (this.anotherPayStatus && this.noMust) {
          return { ...formRules, ...additionalEditFormRules, ...contractNoFormRules };
        } else if (this.noMust) {
          return { ...formRules, ...contractNoFormRules };
        } else if (this.anotherPayStatus) {
          return { ...formRules, ...additionalEditFormRules };
        } else {
          return formRules;
        }
      } else {
        if (this.anotherPayStatus) {
          return { ...formRules, ...editFormRules, ...additionalEditFormRules };
        } else {
          return { ...formRules, ...editFormRules };
        }
      }
    },
  },
  methods: {
    // 切换结算中心
    changeSettlementCenterHandler(val) {
      console.log(val, '切换结算中心');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementCenter: val,
        settlementCenterName: item.personCompanyName,
      };
    },
    // 切换公司
    changeCompanyHandler(val) {
      console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      console.log(item, '切换公司item');
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        settlementCompanyNo: val,
        settlementCompanyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      console.log(val, '切换部门');
      console.log(this.departmentList, 'this.departmentList');

      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: val,
        settlementDepartmentName: item.personDepartmentName,
      };
    },
    // 修改客户
    changeSupplyChainMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        supplierName: rowData?.partnerZhName,
        supplierNo: rowData?.partnerCode,
      };
    },
    // 修改合同
    changeContractMethod(val) {
      const rowData = val[0];
      console.log(rowData, '修改合同');
      this.baseFormData = {
        ...this.baseFormData,
        contractNo: rowData?.contractCode,
        supplierName: rowData?.supplierName,
        supplierNo: rowData?.supplierCode,
        projectInitiationNo: rowData?.projectCode,
        projectName: rowData?.projectName,
        exchangeRate: '1',
        currencyCode: rowData?.contractCurrency ? rowData?.contractCurrency : 'CNY',
        currencyName: rowData?.contractCurrencyName
          ? rowData?.contractCurrencyName
          : '中国人民币（国际）',
      };
      //清除结算行和明细行
      this.$refs?.lineDetails?.removeRowHandler();
      this.$refs.linesRef.removeRowHandler();
      this.settleAccountsRowList = [];
      this.settleAccountsDetailMap = new Map();
      this.currentSettleAccountDetailList = [];
      this.currentSettleAccountRowData = null;
      this.currentDetailData = {};
      //清除基本信息
      this.baseFormData = {
        ...this.baseFormData,
        originalTotalAmount: '0',
        originalTotalAmountWithoutTax: '0',
        originalTotalTaxAmount: '0',
        domesticTotalAmount: '0',
        domesticTotalAmountWithoutTax: '0',
        domesticTotalTaxAmount: '0',
        paidAmount: '0',
        unpaidAmount: '0',
        isMoreDeliverer: '0',
        orderNo: '',
      };
      //清除抵扣行
      this.$refs?.DeductionRow?.removeRowHandler();
      this.deductions = [];
      this.deductionDetails = [];
      //清除关联预结算
      this.$refs?.relatedRow?.removeRowHandler();
      this.preSettlements = [];
      //清除关联预付款
      this.$refs?.payRow?.removeRowHandler();
      this.advancePayments = [];
      // if (rowData.orderDetailList && rowData.orderDetailList.length) {
      //   this.productList = [];
      //   rowData.orderDetailList.map((item) => {
      //     if (item.productDesc && item.productNo) {
      //       this.productList.push({
      //         label: item.productDesc,
      //         value: item.productNo,
      //         contractDetailId: item.id,
      //         taxRate: item.taxRate,
      //       });
      //     }
      //   });
      // }
    },
    // 修改业务员
    changePersonnelMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        salesmanNo: rowData?.personNo,
        salesmanName: rowData?.personName,
      };
    },
    // // 修改编制人员
    // changeWeaveMethod(val) {
    //   const rowData = val[0];
    //   this.baseFormData = {
    //     ...this.baseFormData,
    //     weaveNo: rowData?.personNo,
    //     weaveName: rowData?.personName,
    //   };
    // },
    // 切换货币
    changeCurrencyHandler({ val }) {
      this.baseFormData = {
        ...this.baseFormData,
        currencyCode: val?.currencyCode,
        currencyName: val?.currencyName,
      };
      this.$emit('changeCurrencyHandler', val);
    },
  },
  mounted() {
    this.isCreate = ['create', 'edit'].includes(this.$route.query?.status);
  },
};
